export default __webpack_public_path__ + "static/media/circle_icon.c2dabd8d.svg";